import * as React from 'react';
import { JSX } from 'react';
import NavigateWithAppName from './common/NavigateWithAppName';
import { isWebApp } from '../lib/utils';
import config from '../config.general';
import { prodEnvironments, protectedFallbackPageUrl } from '../core/constants';

const MobileOnlyRoute = ({ children }: { children: JSX.Element }) => {
	if (isWebApp && prodEnvironments.includes(config.environment)) {
		return <NavigateWithAppName to={protectedFallbackPageUrl} replace />;
	}

	return children;
};

export default MobileOnlyRoute;
